import { diditInboxQueryKeys as e } from "./diditInboxQueryKeys.mjs";
import { useQueryClient as t } from "@maat/store-hooks";
import { useCallback as n } from "react";
//#region src/verification/admin/useInvalidateDiditInbox.ts
var r = () => {
	let r = t();
	return n(() => {
		r.invalidateQueries({ queryKey: e.list() }), r.invalidateQueries({ queryKey: e.stats() });
	}, [r]);
};
//#endregion
export { r as useInvalidateDiditInbox };
